module.exports = __webpack_public_path__ + "acf9c5c07f44dddfa9dd2766fcd6c0aa.woff";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-bold-webfont.woff
// module id = 339
// module chunks = 0